<template>
  <div class="day-item">
    <span class="day">{{ dayjs(invoiceDetail.createdAt).format('YY. MM .DD (ddd)') }}</span>
    <ul class="day-list">
      <li class="flex-btw">
        <div class="info-left info-item">
          <div class="inr">
            <p class="dim2">
              {{ dayjs(invoiceDetail.createdAt).format('HH:mm') }}
            </p>
            <div class="under-txt">
              <p>{{ textTag }}</p>
              <p class="line"></p>
              <p>{{ invoiceDetail.cardName }} {{ invoiceDetail.cardNumber }}</p>
            </div>
          </div>
        </div>
        <div class="info-right info-item">
          <strong class="price">{{ getTextMoney(invoiceDetail.amount) }}</strong>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import dayjs from 'dayjs';

import IconCheck from '@/components/icons/IconCheck.vue';
import IconClose from '@/components/icons/IconClose.vue';
import { IResponsePaymentHistory } from '@/types/response';
import { formatNumberWithComma } from '@/utils/stringUtils.js';

const { t } = useI18n();

const { invoiceDetail } = defineProps<{
  invoiceDetail: IResponsePaymentHistory;
}>();

// 결제 완료 / 결제 취소 반환
const textTag = computed(() => {
  const mapLabelTag = {
    SUCCESS: t('ss_history_type_payment'),
    CANCELED: t('label_cancel'),
  };
  return mapLabelTag[invoiceDetail.status];
});

// 태그 아이콘 반환
const iconTag = computed(() => {
  return {
    SUCCESS: IconCheck,
    CANCELED: IconClose,
  }[invoiceDetail.status];
});

// 태그 클래스 반환
const typeTag = computed(() => {
  const mapTypeTag = {
    SUCCESS: 'info-light',
    CANCELED: 'error-light',
  };
  return mapTypeTag[invoiceDetail.status];
});

// 금액 문구 반환
const getTextMoney = (amount: number) => {
  const isUsd = invoiceDetail.currency === 'USD';
  const amountFormatted = formatNumberWithComma(amount);
  return isUsd ? `$${amountFormatted}` : `${amountFormatted} ${t('label_currency_won')}`;
};
</script>

<style scoped lang="scss">
.day-item {
  margin-top: 1.5rem;
  .day {
    display: block;
    font-size: $font-size-psmall;
    margin-bottom: 0.5rem;
  }
  .day-list {
    border-top: 1px solid $color-gray-900;
    li {
      border-bottom: 1px solid $color-gray-40;
      padding: 1rem 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info-left {
        margin-bottom: 0.5rem;
        .inr {
          p {
            font-size: $font-size-psmall;
          }
        }
        .under-txt {
          display: flex;
          align-items: center;
          gap: $size-s;
          p {
            &.line {
              width: 1px;
              height: 10px;
              background: $color-gray-90;
            }
          }
        }
        span {
          display: block;
          font-size: $font-size-xs;
          &.time {
            color: $color-gray-100;
            display: block;
            margin-bottom: $size-s;
          }
        }
      }
      .info-right {
        font-weight: 600;
        .amount {
          &.delect {
            color: $new-warning;
          }
        }
      }
    }
  }
}
</style>
